/**
 * /share/$token — public share-card preview (Phase 8 M8).
 *
 * Decodes the token via `decodeShareToken` (self-contained, no Kairos
 * round-trip yet) and renders one of three humane states inside
 * `<SharePreviewPublic>`: valid card, expired, invalid. Never throws,
 * never shows "Something went wrong".
 *
 * The route lives at `/share/$token` so the URL is human-readable when
 * the link is shared (the token is opaque, but the path prefix tells
 * the recipient what to expect).
 */
import { useParams } from '@tanstack/react-router'

import { SharePreviewPublic } from '@/modules/share'

export function SharePage() {
  // TanStack will type-check this at register time. We cast through
  // `Record<string, string>` because the type-only route tree (see
  // `router.ts`) is the source of truth; a missing param would already
  // have failed the route registration.
  const params = useParams({ strict: false }) as { token?: string }
  return <SharePreviewPublic token={params.token ?? null} />
}
